.stepperWrapper {
	position: relative;
	max-width: 100%;
}

.stepper {
	padding: 4px;
	overflow-x: auto;
}

.scrollGradient {
	position: absolute;
	top: 0;
	right: 0;
	height: 100%;
	width: 80px;
	margin-right: -1px;
	z-index: 2;
	pointer-events: none;
	opacity: 0;
	background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
	transition: opacity 0.2s;
}

.stepArrowWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	& svg {
		width: 20px;
		height: 20px;
		color: #42296e;
		transform: rotate(90deg);
	}

	&.expanded {
		padding-right: 0;
	}

	&.expanded svg {
		transform: unset;
	}
}

.verticalStepperWrapper {
	background-color: #fbfbfb;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	height: 100%;
	width: 100%;
	border-radius: 20px;
	border: 1px solid #e2e2e2;
	padding: 1.25rem 0rem 2rem 0.5rem;
	overflow: auto;
	box-sizing: border-box;
}

.verticalStepperWrapper:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: -2px;
}
